const placeholder = [
    '/thumbnails/thumbnail_1.png',
    '/thumbnails/broken_asset.png',
];


const getPlaceholderThumbnail = (indx = 0) => { return placeholder[indx] };

export { getPlaceholderThumbnail, placeholder };